import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchOutlined } from "@ant-design/icons";
import { Input, Table } from "antd";
import { useCallback } from "react";
import { useI18n } from "../contexts";
const { Column } = Table;
function useTableColumnFilterSimpleInput() {
    const { __ } = useI18n();
    return useCallback(()=>{
        return {
            filterDropdown: (param)=>{
                let { setSelectedKeys, selectedKeys, confirm, clearFilters } = param;
                return /*#__PURE__*/ _jsxs("div", {
                    style: {
                        padding: 8
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Input, {
                            autoFocus: true,
                            value: selectedKeys[0],
                            onChange: (e)=>setSelectedKeys(e.target.value ? [
                                    e.target.value
                                ] : []),
                            style: {
                                width: 188,
                                marginBottom: 8,
                                display: "block"
                            }
                        }),
                        /*#__PURE__*/ _jsxs("button", {
                            className: "button-primary right",
                            style: {
                                marginLeft: 10
                            },
                            onClick: ()=>confirm(),
                            children: [
                                /*#__PURE__*/ _jsx(SearchOutlined, {}),
                                " ",
                                __("Search")
                            ]
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "button right",
                            onClick: clearFilters,
                            children: __("Reset")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "clear"
                        })
                    ]
                });
            },
            filterIcon: (filtered)=>/*#__PURE__*/ _jsx(SearchOutlined, {
                    style: {
                        color: filtered ? "#1890ff" : undefined
                    }
                })
        };
    }, []);
}
export { useTableColumnFilterSimpleInput };
